import {Button, localStorageStore, TopToolbar, useRecordContext} from "react-admin";
import * as React from "react";
import { GetApp } from "@mui/icons-material";
import { useKeycloak } from '@react-keycloak/web'

const ShowActionsAbholungenExport = (props) => {
    const {keycloak, initialized} = useKeycloak()
    const record = useRecordContext();
    const store = localStorageStore();
    const apiUrl = store.getItem('apiUrl');

    return (
        <TopToolbar {...props}>
            <Button
                onClick={() => {
                    var abholdatum = new Date(record.abholdatum);
                    fetch(
                        apiUrl + '/anmeldungen-export' +
                        '?abholgebiet=' + record.abholgebiet.id +
                        '&abholtermin=' + abholdatum.toISOString().slice(0, 10),
                        {
                            headers: {
                                'Accept': 'application/json',
                                'Authorization': 'Bearer ' + keycloak.token
                            }
                        }
                    )
                        .then(response => response.json())
                        .then(json => {
                            window.location = json.url;
                        })
                }}
                label="Export Anmeldungen"
            >
                <GetApp/>
            </Button>
        </TopToolbar>
    )
}

export default ShowActionsAbholungenExport;